import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {PIXI} from '@colonist/pixi'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {UIGameManager} from '../UIGameManager'
import {GameStateEnums, ModeSettingEnum} from '../../../../../shared/GameEnums'
import {UIGamePlayerInformationWaitIconView} from './UIGamePlayerInformationWaitIconView'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameOpponentsViewScrollAnimationController} from './UIGameOpponentsViewScrollAnimationController'
import {UIGameOpponentsScrollbox} from './UIGameOpponentsScrollbox'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGamePlayerInformationRobberView} from '../ui_game_cities_and_knights/UIGamePlayerInformationRobberView'
import {
    MechanicCityImprovementsState,
    MechanicCityState,
    MechanicCityWallState,
    MechanicDevelopmentCardsState,
    MechanicLargestArmyState,
    MechanicLongestRoadState,
    MechanicProgressCardsState,
    MechanicRoadState,
    MechanicSettlementState,
    MechanicSpecialBuildPhaseState,
    PlayerColor,
} from '@colonist/game-states'
import {
    MechanicValidatorCity,
    MechanicValidatorCityImprovements,
    MechanicValidatorCityWall,
    MechanicValidatorDevelopmentCard,
    MechanicValidatorLargestArmy,
    MechanicValidatorLongestRoad,
    MechanicValidatorProgressCards,
    MechanicValidatorRoad,
    MechanicValidatorSettlement,
    Point,
} from '@colonist/game-mechanic-validators'
import {BeginnerModeActionState} from '@colonist/game-state-types'
import {HiddenUIElement} from '@colonist/game-beginner-mode'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {PlayerInformationContainerPosition} from '@colonist/ui-game'

export abstract class UIGamePlayersController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    protected readonly developmentCardsValidator?: MechanicValidatorDevelopmentCard
    protected readonly progressCardsValidator?: MechanicValidatorProgressCards
    protected readonly settlementValidator?: MechanicValidatorSettlement
    protected readonly cityValidator?: MechanicValidatorCity
    protected readonly cityWallValidator?: MechanicValidatorCityWall
    protected readonly cityImprovementsValidator?: MechanicValidatorCityImprovements
    protected readonly roadValidator?: MechanicValidatorRoad
    protected readonly longestRoadValidator?: MechanicValidatorLongestRoad
    protected readonly largestArmyValidator?: MechanicValidatorLargestArmy
    protected readonly specialBuildPhaseState: MechanicSpecialBuildPhaseState | undefined

    container: SectionBgView
    protected scrollAnimationController: UIGameOpponentsViewScrollAnimationController

    opponentsScrollbox: UIGameOpponentsScrollbox
    protected playerContainer: PIXI.Container
    playerInformationViews: UIGamePlayerInformationView[] = []
    protected playerInformationWaitIconViews: UIGamePlayerInformationWaitIconView[] = []
    protected robberPlayerInformationViews: UIGamePlayerInformationRobberView[] = []

    currentBeginnerModeAction?: BeginnerModeActionState
    protected portraitPlayerInformationContainerPosition: PlayerInformationContainerPosition | null = null

    constructor(uiGameManager: UIGameManager,
                developmentCardsState: MechanicDevelopmentCardsState | undefined,
                progressCardsState: MechanicProgressCardsState | undefined,
                settlementState: MechanicSettlementState | undefined,
                cityState: MechanicCityState | undefined,
                cityWallState: MechanicCityWallState | undefined,
                cityImprovementsState: MechanicCityImprovementsState | undefined,
                roadState: MechanicRoadState | undefined,
                longestRoadState: MechanicLongestRoadState | undefined,
                largestArmyState: MechanicLargestArmyState | undefined,
                specialBuildPhaseState: MechanicSpecialBuildPhaseState | undefined) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        if(developmentCardsState) this.developmentCardsValidator = new MechanicValidatorDevelopmentCard(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, developmentCardsState)
        if(progressCardsState) this.progressCardsValidator = new MechanicValidatorProgressCards(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, progressCardsState)
        if(settlementState) this.settlementValidator = new MechanicValidatorSettlement(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, settlementState)
        if(cityState) this.cityValidator = new MechanicValidatorCity(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, cityState)
        if(cityWallState) this.cityWallValidator = new MechanicValidatorCityWall(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, cityWallState)
        if(cityImprovementsState) this.cityImprovementsValidator = new MechanicValidatorCityImprovements(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, cityImprovementsState)
        if(roadState) this.roadValidator = new MechanicValidatorRoad(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, roadState)
        if(longestRoadState) this.longestRoadValidator = new MechanicValidatorLongestRoad(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, longestRoadState)
        if(largestArmyState) this.largestArmyValidator = new MechanicValidatorLargestArmy(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, largestArmyState)
        this.specialBuildPhaseState = specialBuildPhaseState
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        if(this.uiGameManager.canvasController.app.stage.destroyed) return

        switch(eventType) {
            case UIGameEventEnums.CanvasResized: this.onCanvasResize(); break
            case UIGameEventEnums.GameStateUpdated: this.scrollToCurrentTurnPlayer(true); break
            case UIGameEventEnums.BeginnerModeActionUpdated: this.hideElementsForBeginnerMode(data); break
            default: break
        }
    }

    protected abstract createOpponentPlayerInformationViews(partitionH: number, partitionW: number, bottomPlayerColor: PlayerColor)
    protected abstract createMyPlayerInformationView(partitionH: number, partitionW: number, bottomPlayerColor: PlayerColor)
    protected abstract onCanvasResize(): void
    protected abstract scrollToCurrentTurnPlayer(shouldAnimateScroll: boolean): void

    protected initPlayerInformationWaitIconViews() {
        if(this.uiGameManager.gameController.isReplay) return
        this.playerInformationWaitIconViews.forEach((view) => view.destroy())
        this.playerInformationWaitIconViews = []

        for(const playerInformation of this.playerInformationViews) {
            if(playerInformation.player.color == this.uiGameManager.gameController.myColor) continue
            this.playerInformationWaitIconViews.push(new UIGamePlayerInformationWaitIconView(this.uiGameManager, playerInformation))
        }
    }

    protected initRobberPlayerInformationViews() {
        if(this.uiGameManager.gameController.isReplay) return
        if(this.uiGameManager.gameController.gameSettings.modeSetting != ModeSettingEnum.ColonistRush4P) return

        this.robberPlayerInformationViews.forEach((view) => view.destroy())
        this.robberPlayerInformationViews = []

        for(const playerInformation of this.playerInformationViews) {
            this.robberPlayerInformationViews.push(new UIGamePlayerInformationRobberView(this.uiGameManager, playerInformation))
        }
    }

    protected createContainers(x: number, y: number, w: number, h: number, container: PIXI.Container, hideScroll: boolean) {
        const opponentH = (UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && UIUtilsEjsVariables.isUserOnMobileApp) ? h : h / 4.5 * 3
        const playerH = h / 4.5 * 1.5

        this.container = new SectionBgView(x, y, w, h, container, true)

        this.container.makeRoundedBgInvisible()
        this.container.interactive = true

        this.opponentsScrollbox = new UIGameOpponentsScrollbox(0, 0, w, opponentH, this.container, this.uiGameManager, hideScroll)

        this.playerContainer = new SectionView(0, h - playerH, w, playerH, this.container, true)

        if(UIUtilsEjsVariables.isUserOnMobile) return
        this.container.on('pointerout', (event) => {
            this.uiGameManager.eventController.sendEvent(undefined, GameStateEnums.UIGameEventEnums.PointerOutPlayerInformationView)
        })
    }

    getPlayerInformationViewWithColor(color: PlayerColor): UIGamePlayerInformationView | undefined {
        for(const playerInformation of this.playerInformationViews) {
            if(playerInformation.player.color == color) return playerInformation
        }
        return undefined
    }

    getGlobalPositionOfPlayerResCard(playerColor: PlayerColor): Point | undefined {
        for(const playerInformation of this.playerInformationViews) {
            if(playerInformation.player.color == playerColor) return playerInformation.resourceCardView.view.getGlobalPosition()
        }
        return undefined
    }

    getGlobalPositionOfPlayerDevelopmentCard(playerColor: PlayerColor): Point | undefined {
        for(const playerInformation of this.playerInformationViews) {
            if(playerInformation.player.color != playerColor) continue
            return playerInformation.developmentCardView.view.getGlobalPosition()
        }
        return undefined
    }

    protected createAllPlayers() {
        if(this.areViewsCreated()) return
        const partitionH = this.container.height / 4.5
        const partitionW = this.container.width

        const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor

        this.createOpponentPlayerInformationViews(partitionH, partitionW, bottomPlayerColor)
        this.createMyPlayerInformationView(partitionH, partitionW, bottomPlayerColor)
    }

    private areViewsCreated(): boolean {
        return this.playerInformationViews.length > 0
    }

    /**
     * @deprecated Use UIGamePlayerInformationContainer.tsx getPlayerOrderWhereMyColorIsLast instead
     */
    protected getPlayerOrderWhereMyColorIsLast(): PlayerColor[] {
        if(this.uiGameManager.gameController.myColor == PlayerColor.None) return this.uiGameManager.gameController.playOrder
        const newOrder: PlayerColor[] = []

        const myColorIndex = this.uiGameManager.gameController.playOrder.indexOf(this.uiGameManager.gameController.myColor)
        const numberOfPlayers = this.uiGameManager.gameController.playOrder.length
        const indexOfPlayerAfterMe = myColorIndex + 1
        for(let index = indexOfPlayerAfterMe; index <= numberOfPlayers + myColorIndex; index++) {
            newOrder.push(this.uiGameManager.gameController.playOrder[index % numberOfPlayers])
        }
        return newOrder
    }

    protected initScrollAnimationController() {
        if(!this.opponentsScrollbox.isScrollable) return
        this.scrollAnimationController = new UIGameOpponentsViewScrollAnimationController(this.uiGameManager, this.opponentsScrollbox)
    }

    protected hideElementsForBeginnerMode(data?: BeginnerModeActionState) {
        if(data != undefined) this.currentBeginnerModeAction = data

        const isMechanicDevelopmentCardsEnabled = this.developmentCardsValidator !== undefined
        const isMechanicProgressCardsEnabled = this.progressCardsValidator !== undefined
        if(isMechanicDevelopmentCardsEnabled || isMechanicProgressCardsEnabled) return

        for(const playerInformation of this.playerInformationViews) playerInformation.developmentCardView.visible = false

        if(!this.currentBeginnerModeAction?.hiddenUIElements.includes(HiddenUIElement.PlayerViewResourceCards)) return
        for(const playerInformation of this.playerInformationViews) playerInformation.resourceCardView.visible = false
    }
}
